<template>
  <button
    class="whitespace-nowrap text-[1.3rem] md:text-[1.4rem] px-4 py-[1.1rem] sm:px-6 md:px-[3.2rem] md:py-[1.2rem] rounded-[10rem] border border-white"
  >
    <slot></slot>
  </button>
</template>

<script>

import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseButton',
  props: {

  }
});
</script>

<style scoped>
.button {
}
</style>
